import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Constants } from '../common/Constants';
import * as CryptoJS from 'crypto-js';
import { SeoSettings } from '../SeoSettings';
import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  isPageDataLoaded: boolean = true;
  isUserASeller: boolean = false;
  loginMessageSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isShowLoader: Subject<boolean> = new Subject<boolean>();
  isShowDataTransferLoader: Subject<boolean> = new Subject<boolean>();
  isVideoCategoryDataAvailable: Subject<boolean> = new Subject<boolean>();
  isUserLocationReset: Subject<boolean> = new Subject<boolean>();
  userCountry = "IN";
  private userId;
  ipAddress = "";
  encryptSecretKey = "john@123";
  videoCategoryData: any;
  cardCategoryData: any;
  isAdminLoggedIn: Subject<boolean> = new Subject<boolean>();
  public adminEmails = ["247invitesservice@gmail.com"];
  public supportEmails = ["Vernon.Dsouza@gmail.com", "NSales1@gmail.com"];
  /**
   *
   */
  constructor(@Inject(PLATFORM_ID) private platformId, private httpClient: HttpClient) {


  }
  set userToEdit(userId) {
    this.userId = userId;
  }

  get userToEdit() {
    return this.userId;
  }
  encryptData(data) {
    // if (isPlatformServer(this.platformId)) {
    //   return Buffer.from(data, 'binary').toString('base64');
    // }
    // else
    return btoa(data).replace('/', '*');
  }

  decryptData(data): any {
    // if (isPlatformServer(this.platformId)) {
    //   // console.log(Buffer.from(data, 'base64').toString('binary'));
    //   console.log(JSON.parse(Buffer.from(data, 'base64').toString('binary')));
    //   return JSON.parse(Buffer.from(data, 'base64').toString('binary'));
    // }
    // else
    return JSON.parse(atob(data).replace('*', '/'));
  }
  queryStringToObject(queryString) {
    if (queryString == undefined)
      return;
    const pairs = queryString.split('&');
    // → ["foo=bar", "baz=buzz"]

    var array = pairs.map((el) => {
      const parts = el.split('=');
      return parts;
    });
    // → [["foo", "bar"], ["baz", "buzz"]]

    return JSON.stringify(Object.fromEntries(array));;
    // → { "foo": "bar", "baz": "buzz" }
  }
  public decryptAndParseQueryString(encryptedData: string) {
    let templateId = 0;
    let categoryId = 0;
    let subCategoryId = 0;
    let videoId = 0;
    let userVideoId = 0;
    let cardId = 0;
    let userCardId = 0;
    let marketingAgent = "";
    let isPaymentFail = false;
    let isFromHistory = false;
    let isEditForMe = false;
    let invitationType = 1;
    let isFromPayment = false;

    if (encryptedData === undefined || encryptedData === null) {
      return;
    }
    const decryptparams = this.decryptData(encryptedData);
    if (decryptparams == undefined)
      return;
    if (decryptparams.templateId !== undefined && decryptparams.templateId !== null) {
      templateId = parseInt(decryptparams.templateId);
    }

    if (decryptparams.categoryId !== undefined && decryptparams.categoryId !== null) {
      categoryId = parseInt(decryptparams.categoryId);
    }

    if (decryptparams.subCategoryId !== undefined && decryptparams.subCategoryId !== null) {
      subCategoryId = parseInt(decryptparams.subCategoryId);
    }
    if (decryptparams.videoId !== undefined && decryptparams.videoId !== null) {
      videoId = parseInt(decryptparams.videoId);
    }
    if (decryptparams.userVideoId !== undefined && decryptparams.userVideoId !== null) {
      userVideoId = parseInt(decryptparams.userVideoId);
    }
    if (decryptparams.cardId !== undefined && decryptparams.cardId !== null) {
      cardId = parseInt(decryptparams.cardId);
    }
    if (decryptparams.userCardId !== undefined && decryptparams.userCardId !== null) {
      userCardId = parseInt(decryptparams.userCardId);
    }
    if (decryptparams.marketingAgent !== undefined && decryptparams.marketingAgent !== null) {
      marketingAgent = decryptparams.userCardId;
    }
    if (decryptparams.isPaymentFail !== undefined && decryptparams.isPaymentFail !== null) {
      isPaymentFail = decryptparams.isPaymentFail;
    }
    if (decryptparams.isFromHistory !== undefined && decryptparams.isFromHistory !== null) {
      isFromHistory = decryptparams.isFromHistory;
    }
    if (decryptparams.isEditForMe !== undefined && decryptparams.isEditForMe !== null) {
      isEditForMe = decryptparams.isEditForMe;
    }
    if (decryptparams.invitationType !== undefined && decryptparams.invitationType !== null) {
      invitationType = decryptparams.invitationType;
    }
    if (decryptparams.isFromPayment !== undefined && decryptparams.isFromPayment !== null) {
      isFromPayment = decryptparams.isFromPayment;
    }
    return {
      templateId: templateId,
      categoryId: categoryId,
      subCategoryId: subCategoryId,
      videoId: videoId,
      userVideoId: userVideoId,
      cardId: cardId,
      userCardId: userCardId,
      marketingAgent: marketingAgent,
      isPaymentFail: isPaymentFail,
      isFromHistory: isFromHistory,
      isEditForMe: isEditForMe,
      invitationType: invitationType,
      isFromPayment: isFromPayment
    };
  }
  getSeoTags(isVideoPage: boolean, categoryId, subCategoryId, categoryName, subCategoryName) {
    let seoTags: { metaTitle: any, metaDescription: any, metaKeywords: any };
    if (categoryId == 1 && subCategoryId == 0 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.WEDDING_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.WEDDING_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.WEDDING_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 2 && subCategoryId == 0 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.BIRTHDAY_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.BIRTHDAY_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.BIRTHDAY_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 3 && subCategoryId == 0 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.GREETINGS_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.GREETINGS_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.GREETINGS_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 4 && subCategoryId == 0 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.BABY_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.BABY_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.BABY_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 1 && subCategoryId == 2 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.ENGAGMENT_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.ENGAGMENT_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.ENGAGMENT_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 1 && subCategoryId == 3 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.WEDDING_INVITE_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.WEDDING_INVITE_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.WEDDING_INVITE_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 2 && subCategoryId == 4 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.BIRTHDAY_INVITE_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.BIRTHDAY_INVITE_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.BIRTHDAY_INVITE_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 4 && subCategoryId == 5 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.BABY_SHOWER_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.BABY_SHOWER_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.BABY_SHOWER_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 6 && subCategoryId == 3 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.BIRTHDAY_GREETING_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.BIRTHDAY_GREETING_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.BIRTHDAY_GREETING_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 7 && subCategoryId == 3 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.DIWALI_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.DIWALI_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.DIWALI_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 8 && subCategoryId == 4 && isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.HALF_SAREE_VIDEOS_META_TITLE,
        metaDescription: SeoSettings.HALF_SAREE_VIDEOS_META_DESCRIPTION,
        metaKeywords: SeoSettings.HALF_SAREE_VIDEOS_META_KEYWORD
      }
    }
    else if (categoryId == 1 && subCategoryId == 0 && !isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.WEDDING_CARDS_META_TITLE,
        metaDescription: SeoSettings.WEDDING_CARDS_META_DESCRIPTION,
        metaKeywords: SeoSettings.WEDDING_CARDS_META_KEYWORD
      }
    }
    else if (categoryId == 2 && subCategoryId == 0 && !isVideoPage) {
      seoTags = {
        metaTitle: SeoSettings.BIRTHDAY_CARDS_META_TITLE,
        metaDescription: SeoSettings.BIRTHDAY_CARDS_META_DESCRIPTION,
        metaKeywords: SeoSettings.BIRTHDAY_CARDS_META_KEYWORD
      }
    }
    else if (isVideoPage) {
      if (subCategoryName == null)
        subCategoryName = categoryName;
      seoTags = {
        metaTitle: `${subCategoryName} Invitation Video Maker | 247 Invites`,
        metaDescription: `247 Invites ${subCategoryName} invitation video maker online has just the invitation maker for you. Choose from our online wedding Invitations and e-card templates.`,
        metaKeywords: `${subCategoryName} video invitations, online ${subCategoryName} invitation video, ${subCategoryName} invitation video maker, ${subCategoryName} video invitation maker `
      }
    }
    else {
      if (subCategoryName == null)
        subCategoryName = categoryName;
      seoTags = {
        metaTitle: `${subCategoryName} Invitation card Maker | 247 Invites`,
        metaDescription: `247 Invites ${subCategoryName} invitation card maker online has just the invitation maker for you. Choose from our online wedding Invitations and e-card templates.`,
        metaKeywords: `${subCategoryName} card invitations, online ${subCategoryName} invitation card, ${subCategoryName} invitation card maker, ${subCategoryName} card invitation maker `
      }
    }
    return seoTags;
  }
  imageToBase64(imageUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.httpClient.get(imageUrl, { responseType: 'blob' }).subscribe(
        (blob) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            resolve(reader.result as string); // Base64 string
          };
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
  base64ToBlob(base64: string): { blob: Blob; name: string } {
      if (base64 == "") {
        return;
      }
      const matches = base64.match(/^data:(.+);base64,(.*)$/);
      if (!matches || matches.length !== 3) {
        throw new Error('Invalid Base64 format');
      }
  
      const mimeType = matches[1]; // Extract MIME type
      const byteCharacters = atob(matches[2]); // Decode Base64 data
      const byteArrays = new Uint8Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays[i] = byteCharacters.charCodeAt(i);
      }
  
      // Create a valid Blob instance
      const blob = new Blob([byteArrays.buffer], { type: mimeType });
  
      // Generate a random file name
      const extension = mimeType.split('/')[1] || 'png'; // Default to PNG if unknown
      const randomName = `image_${Date.now()}_${Math.floor(Math.random() * 10000)}.${extension}`;
  
      return { blob, name: randomName };
    }
}